import { useState } from 'react';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

/**
 * AIトークンエラーモードの状態を管理するフック
 * セッションストレージに状態を保存
 */
export const useAITokenErrorMode = () => {
  const [isAITokenErrorMode, setIsAITokenErrorMode] = useState<boolean>(() =>
    getSessionStorage('debug-ai-token-error-mode'),
  );

  const toggleAITokenErrorMode = (checked: boolean) => {
    setIsAITokenErrorMode(checked);
    setSessionStorage('debug-ai-token-error-mode', checked);
  };

  return {
    isAITokenErrorMode,
    toggleAITokenErrorMode,
  };
};
